// SuperAdminLayout.js - re-use AdminLayout but show super admin nav
import AdminLayout from './AdminLayout';
export default AdminLayout;
